module.exports = __webpack_public_path__ + "img/acslogo.dd7d3a98.png";